import React, { useState, useEffect } from 'react';
import { Route, Link, Switch } from 'react-router-dom';
import './styles/App.css';
import imgA from './img/white 1.png';
import imgB from './img/logo 1.png';
import imgC from './img/facebook 1.png';
import imgD from './img/instagram 1.png';
import imgF from './img/n_icon.png';

function Footer() {
    const cursorPointer = {
        cursor: 'pointer',
    };

    return (
        <>
            <footer>
                <div className="footer">
                    <div className="container footerdown">
                        <div className="row  pl-0 pr-0 mb-5">
                            <div className="col-12 col-lg-7 text-left pl-0 pr-0 mb-lg-0 mb-5">
                                <div className="row pl-0 pr-0">
                                    <div className="col-lg-5 col-12 pl-0 mb-lg-0 mb-5">
                                        <img className="img-fluid" src={imgA} />
                                    </div>
                                    <div className="col-lg-7 col-12 pl-0">
                                        <p className="f_title font-weight-bold text-white mb-0">
                                            (주)티디그룹
                                        </p>
                                        <p className="mb-0 f_inner_text">
                                            대표자 : 김지은 | 사업자번호 :
                                            150-86-01894
                                        </p>
                                        <p className="mb-0 f_inner_text">
                                            경기도 용인시 수지고 광교중앙로 338,
                                            A동 1001호 (광교우미뉴브)
                                        </p>
                                        <p className="mb-0 f_inner_text">
                                            은행 : 국민 649701-01-292970
                                            (주)티디그룹
                                        </p>
                                        <p className="mb-0 f_inner_text copy ">
                                            COPYRIGHT@2021 ALL RIGHTS RESERVED
                                            (주)ABYS.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-8 col-lg-3 f_aboutus">
                                <p className="f_inner_text mb-0">
                                    <span className="f_title font-weight-bold text-white mb-0">
                                        ABOUT US
                                    </span>
                                    <br />
                                    T.1544-2160 <br />
                                    F.031-263-2603 <br />
                                    E.1xymam@scglobal.kr
                                </p>
                                <div className="face-icon">
                                    <Link to="#">
                                        <img
                                            className="fb-icon mr-5"
                                            src={imgC}
                                            onClick={() => {
                                                window.location.replace(
                                                    'https://www.facebook.com/sungardkorea',
                                                );
                                            }}
                                            style={cursorPointer}
                                        />
                                    </Link>
                                    <Link to="#">
                                        <img
                                            className="mr-5"
                                            src={imgD}
                                            onClick={() => {
                                                window.location.replace(
                                                    'https://www.instagram.com/saemmal35',
                                                );
                                            }}
                                            style={cursorPointer}
                                        />
                                    </Link>
                                    <Link to="#">
                                        <img
                                            src={imgF}
                                            onClick={() => {
                                                window.location.replace(
                                                    'https://blog.naver.com/sconestop',
                                                );
                                            }}
                                            style={cursorPointer}
                                        />
                                    </Link>
                                </div>
                            </div>
                            <div
                                className="col-4 col-lg-2 f_c_select"
                                onChange={e => window.open(e.target.value)}>
                                <select className="form-control text-white f_select_style">
                                    <option value="">FamilySite</option>
                                    <option value="http://www.echelon-coating.co.kr">
                                        에슐론유리막
                                    </option>
                                    <option value="http://www.sun-gard.kr">
                                        썬가드썬팅
                                    </option>
                                    <option value="http://www.madico.co.kr">
                                        마디코썬팅
                                    </option>
                                    <option value="http://www.scglobal.kr">
                                        에스씨글로벌
                                    </option>
                                    <option value="https://www.mymall.co.kr">
                                        마이몰
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="footerup">
                        <div className="container py-3">
                            <div className="row p-0">
                                <div className="call-icon col-12 col-lg-6 pl-0 pr-0 text-lg-left text-center">
                                    <span className="f_num_title">
                                        상담전화
                                    </span>
                                    <span className="f_num">1544-2160</span>
                                    <span className="text2">
                                        평일 09:00~18:00( 공ㆍ휴무일 제외)
                                    </span>
                                </div>
                                <div className="col-12 col-lg-6 pl-0 pr-0">
                                    <ul className="f_menu_line_h text-lg-right text-center">
                                        <li
                                            onClick={() => {
                                                alert('준비중입니다.');
                                            }}
                                            style={cursorPointer}>
                                            <Link to="#">
                                                개인정보 처리방침
                                            </Link>
                                        </li>
                                        <li
                                            onClick={() => {
                                                alert('준비중입니다.');
                                            }}
                                            style={cursorPointer}>
                                            <Link to="#">이용약관</Link>
                                        </li>
                                        <li
                                            onClick={() => {
                                                alert('준비중입니다.');
                                            }}
                                            style={cursorPointer}>
                                            <Link to="#">
                                                위치정보수집동의서
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;
